<template>
  <v-chip label :color="getColorCreationDate()">
    {{ date | formatDate2 }}
  </v-chip>
</template>

<script>
export default {
  props: {
    date: String,
    sendDate: String
  },
  methods: {
    getColorCreationDate() {
      let orderAuthorizedDate = new Date(this.date)
      orderAuthorizedDate.setHours(0, 0, 0, 0)
      orderAuthorizedDate.setDate(orderAuthorizedDate.getDate() + 2)
      const actualDate = new Date()
      actualDate.setHours(0, 0, 0, 0)
      if (!this.sendDate && orderAuthorizedDate <= actualDate) {
        return 'red lighten-1'
      } else {
        return 'white'
      }
    },
  },
}
</script>

<style></style>
